// extracted by mini-css-extract-plugin
module.exports = {"teder-button":"styles_teder-button__2lgbk","teder-button-main":"styles_teder-button-main__VL2ya","teder-button-secondary":"styles_teder-button-secondary__1ws5G"};